import type {
  ConversationCategoryData,
  ConversationCategoryReferenceType,
} from "./types.js";
import { language } from "../../base/i18n/setup.js";
import { DataModel } from "../../base/index.js";

export class ConversationCategory extends DataModel<ConversationCategoryData> {
  public static readonly appCategoryId = "b1c735fd-185b-4e50-bb68-36daf6778c85";
  public static readonly generalCategoryId =
    "44bf568f-fb45-4b89-b810-bf558535b09d";
  public static readonly extensionCategoryId =
    "1b761a9d-cc93-41fd-becb-8858f7a67d10";

  public readonly id: string;
  public readonly name: string;
  public readonly translatedName: string;
  public readonly referenceType: ConversationCategoryReferenceType;

  public constructor(data: ConversationCategoryData) {
    super(data);
    this.id = data.categoryId;
    this.name = data.name;
    this.translatedName =
      this.name in language.default.conversation.category
        ? language.default.conversation.category[
            this.name as AvailableCategoryTranslation
          ]
        : this.name;
    this.referenceType = data.referenceType;
  }
}

type AvailableCategoryTranslation =
  | "apps"
  | "articles"
  | "backups"
  | "contractOwner"
  | "cronjobs"
  | "databases"
  | "domains"
  | "emails"
  | "general"
  | "invoices"
  | "payment"
  | "ssh"
  | "workload"
  | "extension";
